import { createContext, useContext, useState, useEffect } from "react";

export interface Operatore {
  id: number;
  nome: string;
  cognome: string;
  email: string;
  tariffa: number;
  id_societa: number;
  role?: string | null;
}

interface UserContextType {
  user: Operatore | null;
  setUser: (user: Operatore | null) => void;
}

const UserContext = createContext<UserContextType>({
  user: null,
  setUser: () => {}
});

export const UserProvider = ({ children }: { children: React.ReactNode }) => {
  // Inizializza lo state leggendo dal sessionStorage
  const [user, setUser] = useState<Operatore | null>(() => {
    try {
      const storedUser = sessionStorage.getItem('user');
      return storedUser ? JSON.parse(storedUser) : null;
    } catch {
      return null;
    }
  });

  // Salva l'utente nel sessionStorage ogni volta che cambia
  useEffect(() => {
    if (user) {
      sessionStorage.setItem('user', JSON.stringify(user));
    } else {
      sessionStorage.removeItem('user');
    }
  }, [user]);

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
